import { Dtos } from "@inrev/common";
import { bondFormFileUrlQueryKey } from "@portal/api/bond";
import { useFetchAdminBondIssuance } from "@portal/api/bond-request/admin";
import { AdminBondRequest } from "@portal/api/bond-request/admin/types";
import { AdminApproveBondFormForAgentIssueForm } from "./AdminApproveBondFormForAgentIssueForm";
import { AdminCompleteInRevIssuedBondFormForm } from "./AdminApproveBondFormForInRevIssueForm";
import { AdminBondFormCard } from "./AdminBondFormCard";
import { AdminCompleteAgentIssuedBondFormForm } from "./AdminUploadAgentIssuedBondFormForm";

type AdminBondRequestBondFormCardProps = {
	request: AdminBondRequest;
	bondForm: Dtos.Admin.SuretyBondForm.Get.Response;
};

export const AdminBondRequestBondFormCard = ({
	request,
	bondForm,
}: AdminBondRequestBondFormCardProps) => {
	const { bondIssuance } = useFetchAdminBondIssuance(request.suretyAccountId, request.id);

	return (
		<AdminBondFormCard
			bondForm={bondForm}
			status={request.status}
			bondFormViewUrl={`/v2/admin/surety/accounts/${request.suretyAccountId}/quotes/${request.id}/bond-form/file`}
			bondFormViewQueryKey={bondFormFileUrlQueryKey(request.id)}
			bottomContent={(() =>
				request.status === "pending" &&
				bondIssuance &&
				(bondIssuance.pendingBondFormReview ||
					bondIssuance.pendingInRevIssue ||
					bondIssuance.pendingAgentIssue ||
					bondIssuance.pendingAgentIssueAdminReview ||
					bondIssuance.method === "electronic" ||
					bondForm.filledWithAdornmentsFileId) && (
					<div className="pt-[35px]">
						<AdminApproveBondFormForAgentIssueForm request={request} bondForm={bondForm} />
						<AdminCompleteInRevIssuedBondFormForm request={request} bondForm={bondForm} />
						<AdminCompleteAgentIssuedBondFormForm request={request} bondForm={bondForm} />
					</div>
				))()}
		/>
	);
};
